import { useMutation } from "react-query"
import { DataBaseService } from "../services/DatabaseService"
import { ReferralPayload } from "../types/ReferralPayload"

type Variables = {
  referralData: ReferralPayload
  id: string
}

export function usePatchReferralData(useVersion2?: boolean) {
  const { mutate, isLoading, isSuccess, isError } = useMutation(
    ["referralPost", useVersion2],
    ({ id, referralData }: Variables) =>
      DataBaseService.patchReferralFormData(id, referralData, useVersion2),
  )

  return { patchReferralData: mutate, isLoading, isSuccess, isError }
}
